import { render, staticRenderFns } from "./AppBoot.vue?vue&type=template&id=2250eedf&"
import script from "./AppBoot.vue?vue&type=script&lang=js&"
export * from "./AppBoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports